import { getChatterList } from "@/api";
import { transformChatterData } from "@/utils/chatterUtils";

export const CHECKPOINT_EVALUATION_CHATTER_TABLE = "checkpoint_evaluation";

export function resolveAccountIdFromStorage(accountIdProp) {
  if (accountIdProp != null && accountIdProp !== "") return accountIdProp;
  try {
    const stored = localStorage.getItem("currentAccountID");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

/** Maps checklist / card payload fields to the checkpoint_evaluation chatter record id. */
export function resolveCheckpointEvaluationRecordId(source = {}) {
  if (source == null || source === "") return null;
  if (typeof source !== "object") return source;
  return (
    source.inspectionId ??
    source.inspection_id ??
    source.evaluation_id ??
    source.evaluationId ??
    source.id ??
    null
  );
}

export async function fetchCheckpointEvaluationChatter(accountId, recordId, page = 1) {
  if (accountId == null || recordId == null) {
    return { results: [], count: 0 };
  }

  const { data } = await getChatterList(
    accountId,
    recordId,
    CHECKPOINT_EVALUATION_CHATTER_TABLE,
    page
  );

  return {
    results: transformChatterData(data?.results || []),
    count: data?.count || 0,
  };
}
